module.exports = __webpack_public_path__ + "static/img/irole.09d8f65.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/sy/irole.png
// module id = bAcC
// module chunks = 7